/**
 * The progression row's chips: for each stored rule its kind and the field it writes, or „Bez
 * progresji". Drawn by the day form's row and by a change under review (`RuleChange`), so the two
 * state a rule the same way.
 */

import type { RuleStatementView } from '../model/ruleStatement';

import styles from './DayProgressionSlots.module.css';

export function StatementChips({ view }: { readonly view: RuleStatementView }) {
  if (view.axes.length === 0) {
    return (
      <span className={styles.chip} title={view.statement}>
        {view.noRule}
      </span>
    );
  }
  return view.axes.map((axis) => (
    <span key={axis.key} className={styles.axis} title={view.statement}>
      {/* The mock's `progKind`, with `PROGC`'s own hue on it. A kind this build has no word for keeps
        * the neutral chip and prints the server's own spelling: a colour nobody chose would be a
        * claim, and the row's whole job is to make only claims it can keep. */}
      {axis.kind !== '' && (
        <span className={styles.chip} data-tone={axis.tone ?? undefined}>
          {axis.kind}
        </span>
      )}
      <span className={styles.axisField}>{axis.field}</span>
    </span>
  ));
}
